import { PayloadAction, createSlice } from "@reduxjs/toolkit";

/**
 * NG-7511: availability of the Google Places (Maps JS) API.
 * - "loading": detection in flight, or not started yet
 * - "available": window.google.maps.places resolved successfully
 * - "unavailable": script failed to load, auth/billing/quota failure, or detection timed out
 *
 * Drives the manual-entry address fallback across the app.
 */
export type TGoogleMapsStatus = "loading" | "available" | "unavailable";

export interface TGoogleMapsStatusState {
    status: TGoogleMapsStatus;
}

const initialState: TGoogleMapsStatusState = {
    status: "loading",
};

const googleMapsStatusSlice = createSlice({
    initialState,
    name: "googleMapsStatusReducer",
    reducers: {
        setGoogleMapsStatus(state: TGoogleMapsStatusState, action: PayloadAction<TGoogleMapsStatus>) {
            return { ...state, status: action.payload };
        },
    },
});

export const { setGoogleMapsStatus } = googleMapsStatusSlice.actions;
export const googleMapsStatusActions = googleMapsStatusSlice.actions;

export default googleMapsStatusSlice.reducer;
